import styled from 'styled-components'
import { poolsContainerCommonStyles } from './PoolCard'

export const HeaderTitle = styled.div`
  position: relative;
  margin-top: 40px;
  text-transform: uppercase;
  ${poolsContainerCommonStyles}

  &::after {
    content: '';
    position: absolute;
    width: 100%;
    height: 1px;
    bottom: -20px;
    background: #c4c4c4;
    opacity: 0.4;
  }
`
